import { LOCATION_CHANGE as ReactRouterLocationChange } from 'modules/router/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

import { BLOCK_LOCATION_CHANGE, FORCE_PAGE_RELOAD, FORCE_PAGE_RELOAD_SUCCESS, UNBLOCK_LOCATION_CHANGE } from '../actionTypes';

/**
 * @typedef {{
 *  updating: boolean,
 *  hasChanged: boolean,
 *  key: string | null,
 *  blocks: Record<string, true>,
 * }} AppLocationReducer
 */

/**
 * @type {AppLocationReducer}
 */
const initialState = {
  updating: false,
  hasChanged: false,
  key: null,
  blocks: {},
};

/**
 * @param {AppLocationReducer} state
 * @returns {AppLocationReducer}
 */
const forcePageReloadStart = state => ({ ...state, updating: true });

/**
 * @param {AppLocationReducer} state
 * @returns {AppLocationReducer}
 */
const forcePageReloadSuccess = state => ({ ...state, updating: false, blocks: {} });

/**
 * @param {AppLocationReducer} state
 * @param {import('modules/global/generic.types').Action<string>} action
 * @returns {AppLocationReducer}
 */
const blockLocationChange = (state, { payload: source }) => ({
  ...state,
  blocks: { ...state.blocks, [source]: true },
});

/**
 * @param {AppLocationReducer} state
 * @param {import('modules/global/generic.types').Action<string>} action
 * @returns {AppLocationReducer}
 */
const unblockLocationChange = (state, { payload: source }) => {
  const { [source]: _removed, ...blocks } = state.blocks;
  return { ...state, blocks };
};

/**
 * @param {AppLocationReducer} state
 * @param {import('modules/global/generic.types').LocationChangeAction} action
 * @returns {AppLocationReducer}
 */
const whenLocationChange = (state, action) => ({
  ...state,
  blocks: {},
  key: action.payload.location.key,
  hasChanged: state.key !== action.payload.location.key,
});

export default createReducer(initialState, {
  [FORCE_PAGE_RELOAD]: forcePageReloadStart,
  [BLOCK_LOCATION_CHANGE]: blockLocationChange,
  [ReactRouterLocationChange]: whenLocationChange,
  [FORCE_PAGE_RELOAD_SUCCESS]: forcePageReloadSuccess,
  [UNBLOCK_LOCATION_CHANGE]: unblockLocationChange,
});
